import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import { AssistanceSection, BenefitSection, BoostSection, CustomSection, FAQ, LargeData, ServicesSection, roleWriting } from '../../Data/All_Services_Data/socialMediaData';
import Custom_section from '../../component/Services_Component/Custom_services_section';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const SocialMediaMarketing = () => {
    useMetaTags({
      title: "Social Media Marketing Services | Warrgyizmorsch Digital Experts",
      description:
        "Warrgyizmorsch offers expert Social Media Marketing Services to grow your brand, boost online visibility, and drive engagement across all major social platforms.",
      keywords:
        "social media marketing services, smm marketing, Social Media Advertising , social media marketing agencies, social media company, social media advertising, smm marketing agency, social media marketing strategies, smm social media marketing, social media management companies, social marketing agencies, paid social media advertising",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h1 className="sec-title text-white">
                  Social Media Marketing Services: Warrgyizmorsch
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/socialmediamarketing.png"
                  loading="lazy"
                  alt="heading_image"
                />
                <div>
                  <p>
                    At Warrgyizmorsch we present social media marketing
                    solutions which are results oriented for brands that are
                    looking to grow fast and smart. We put together services to
                    improve your online presence, build up brand trust, and
                    produce consistent revenue growth. We work with start-ups
                    social media marketing services as well as established
                    businesses to develop strategies that fit your goals and
                    which also target your audience directly.
                  </p>
                </div>
              </div>
              {/* Key Benefits of Social Media Marketing Services */}
              <Handle_Largedata_section LargeData={LargeData} />
              {/* Social Media Advertising Services */}
              <Custom_section data={CustomSection} />
              {/* Which Is the Best Choice for Social Media Advertising - Warrgyizmorsch  */}
              <Boost_section data={BoostSection} />
              {/* Why Choose Us for Social Media Marketing?  */}
              <Assistance_section data={AssistanceSection} />
              {/* FAQ section  */}
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
};

export default SocialMediaMarketing;